import axios from "axios";
import { unzip } from "unzipit";

export async function getZipResponse(
  url: string,
  abortController: AbortController
): Promise<Blob | any | undefined> {
  let lasData: Promise<Blob | any | undefined>;
  try {
    await axios
      .get(url, {
        withCredentials: true,
        responseType: "blob",
        signal: abortController.signal,
      })
      .then(async (res) => {
        const { entries } = await unzip(res.data);
        let blobs: {[key: string]: Blob} = {};
        await Promise.all(Object.entries(entries).map( async ([name, entry]) => {
          const pos = name.lastIndexOf('.');
          const ext = name.slice(pos + 1).toLowerCase();
          
          if (ext === 'ply' || ext === 'las') {
            console.log(`Found PLY/LAS file: ${name}`);
            lasData = entry.blob();
          } else {
            const filename = name.split('/').reverse()[0];
            if (filename[0] !== '.' && entry.size > 0) {
              blobs[`./${filename}`] = await entry.blob()
            }
          }
        }));
        
        console.log(`ZIP processed: ${Object.keys(blobs).length} files loaded`, Object.keys(blobs));
        if (Object.keys(blobs).length > 0) {
          lasData = new Promise((resolve, reject) => {
            resolve(blobs)
          })
        }
      });
  } catch (e) {}
  return lasData;
}
